interface Review {
  author_name: string;
  author_url: string;
  language: string;
  original_language: string;
  profile_photo_url: string;
  rating: number;
  relative_time_description: string;
  text: string;
  time: number;
  translated: boolean;
}
interface widgetData {
  customSwiperClassName?: string;
  customModalClassName?: string;
  placeId: string;
  maxLimit?: number;
  ratingValue?: boolean;
  primaryColor?: string;
}

export class GoogleReview {
  private widgetData: widgetData; // Replace 'any' with the appropriate type
  private swiper: any; // Replace 'any' with the appropriate type
  private swiperCssUrl: string;
  private swiperJsUrl: string;
  private existingPopup: HTMLElement | null = null;
  private primaryColor: string;

  constructor(widgetData: widgetData) {
    this.widgetData = widgetData;
    this.primaryColor = widgetData.primaryColor || '#a81b39';
    this.swiper = null;
    this.swiperCssUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    this.swiperJsUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  }

  private async loadSwiperDependencies(): Promise<void> {
    await this.loadCss(this.swiperCssUrl);
    await this.loadScript(this.swiperJsUrl);
  }

  private loadCss(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  private loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  private applyStyles(): void {
    const componentStyles = `
      .testimonial-carousel {
        padding: 0 50px;
        max-width: 1600px;
        margin-left: auto;
        margin-right: auto;
        &--sm {
          max-width: 660px;
        }
      }

      .testimonial-carousel .swiper-slide {
        width: 320px;
      }

      .testimonial-carousel .swiper-button-prev,
      .testimonial-carousel .swiper-button-next {
        top: 0;
        margin-top: 0;
        background-color: #fff;
        width: 50px;
        height: 100%;
        color: #333;
      }

      .testimonial-carousel .swiper-button-prev {
        left: 0;
      }

      .testimonial-carousel .swiper-button-next {
        right: 0;
      }

      .testimonial-carousel .swiper-button-prev::after,
      .testimonial-carousel .swiper-button-next::after {
        font-size: 30px;
      }

      .t-card {
        font-weight: 300;
      }

      .t-card__text {
        margin-bottom: 10px;
        line-height: 1.4;
      }

      .t-card__text p:last-child {
        margin-bottom: 0;
      }

      .t-card__read-more {
        align-self: end;
        cursor: pointer;
        font-weight: 400;
        margin-bottom: 15px;
      }

      .t-card__read-more:hover,
      .t-card__read-more:focus {
        color: ${this.primaryColor};
      }

      .t-card__bottom {
        display: flex;
        justify-content: space-between;
        gap: 20px;
      }

      .t-card__u-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
      }

      .t-card__u-info__img-box {
        width: 55px;
        height: 55px;
        border: 3px solid #fff;
        border-radius: 100%;
        box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.16);
        font-size: 0.4em;
      }

      .t-card__u-info__img-box img {
        width: 100%;
        height: 100%;
      }

      .t-card__u-info__right {
        flex: 1 1 0;
      }

      .t-card__rating {
        display: flex;
        gap: 10px;
      }

      .t-card__rating__star {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;  
        overflow: hidden;
      }

      .t-card__rating__star .star {
        color: ${this.primaryColor};
      }
      .t-card__google-logo img {
        max-width: 130px;
        width: 100%;
      }

      .testimonial-carousel .t-card {
        padding-left: 20px;
        padding-bottom: 20px;
        position: relative;
        margin-right: 10px;
      }

      .testimonial-carousel .t-card::after {
        content: '';
        border: 3px solid ${this.primaryColor};
        position: absolute;
        top: 20px;
        left: 0;
        height: calc(100% - 20px);
        width: calc(100% - 20px);
      }

      .testimonial-carousel .t-card__inner {
        padding: 25px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        color: #333;
        border-radius: 5px;
        box-shadow: 0 4px 30px rgba(117,116,181,.2);
        position: relative;
        z-index: 1;
      }

      .testimonial-carousel .t-card__text {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;  
        overflow: hidden;
      }

      .testimonial-carousel .t-card__text p {
        margin-bottom: 0;
      }

      .testimonial-carousel .t-card__bottom {
        flex-direction: column;
      }

      .modal {
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        height: 100svh;
        width: 100vw;
        display: none;
      }

      .modal__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        max-width: 750px;
        width: calc(100% - 30px);
        border-radius: 10px;
        overflow: hidden;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
      }

      .modal__header {
        background-color: ${this.primaryColor};
        padding: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        z-index: 2;
      }

      .modal__title {
        color: #fff;
        margin-bottom: 0;
        font-weight: 400;
        font-size: 16px;
      }

      .modal__header .close {
        font-size: 0;
        border: none;
        background-color: transparent;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='100' height='100' viewBox='0,0,256,256'%3E%3Cg fill='%23ffffff' fill-rule='nonzero' stroke='none' stroke-width='1' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='10' stroke-dasharray='' stroke-dashoffset='0' font-family='none' font-weight='none' font-size='none' text-anchor='none' style='mix-blend-mode: normal'%3E%3Cg transform='scale(5.12,5.12)'%3E%3Cpath d='M7.71875,6.28125l-1.4375,1.4375l17.28125,17.28125l-17.28125,17.28125l1.4375,1.4375l17.28125,-17.28125l17.28125,17.28125l1.4375,-1.4375l-17.28125,-17.28125l17.28125,-17.28125l-1.4375,-1.4375l-17.28125,17.28125z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        width: 24px;
        height: 24px;
        background-size: 100%;
        cursor: pointer;
      }

      .modal__body {
        padding: 15px;
        height: calc(100% - 54px);
        overflow-y: auto;
      }

      .testimonial-modal .t-card {
        height: 100%;
      }

      .testimonial-modal .t-card__text {
        margin-bottom: 30px;
      }

     

      @media (max-width: 992px) {
        .testimonial-carousel {
          padding: 0;
        }
        .testimonial-carousel .swiper-button-next,
        .testimonial-carousel .swiper-button-prev {
          display: none;
        }
      }

      @media (max-width: 575px) {
        .testimonial-carousel .swiper-slide {
          width: 280px;
        }
        .t-card__bottom {
          flex-direction: column;
        }
      }
    `;

    const styleElement = document.createElement('style');
    styleElement.textContent = componentStyles;
    document.head.appendChild(styleElement);
  }

  private createSwiperContainer(): HTMLElement {
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('testimonial-carousel'); // Add the 'swiper-container' class
    sliderContainer.classList.add('swiper');
    if (this.widgetData.customSwiperClassName !== undefined && this.widgetData.customSwiperClassName !== null) {
      sliderContainer.classList.add(this.widgetData.customSwiperClassName);
    }
    sliderContainer.innerHTML = `
      <div class="swiper-wrapper"></div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    `;

    return sliderContainer;
  }

  private createPopup(details: Review): HTMLElement {
    console.log('details', details);
    if (this.existingPopup) {
      return this.existingPopup;
    }

    const popup = document.createElement('div');
    popup.classList.add('testimonial-modal');
    popup.classList.add('modal');
    if (this.widgetData.customModalClassName !== undefined && this.widgetData.customModalClassName !== null) {
      popup.classList.add(this.widgetData.customModalClassName);
    }

    // Embedded styles for the popup
    popup.style.zIndex = '9999';
    popup.style.display = 'none';

    popup.innerHTML = `
        <div class="modal__content">
          <div class="modal__header">
            <h5 class="modal__title">Review by : Michael Maniatis</h5>
            <button type="button" class="close">Close</button>
          </div>
          <div class="modal-body">
            <div class="t-card">
              <div class="t-card__inner">
                <div class="t-card__text">
                  <p>${details.text}</p>
                  
                </div>
                <div class="t-card__bottom">
                  <div class="t-card__u-info">
                    <div class="t-card__u-info__img-box">
                      <img src="https://lh3.googleusercontent.com/a/ACg8ocJYXRHLfBHsjuDQLRaZxlbKzeeQt2kGj1ADHXH7S23V=s128-c0x00000000-cc-rp-mo" alt="Melissa Shelly">
                    </div>
                    <div class="t-card__u-info__right">
                      <div class="t-card__name">Melissa Shelly</div>
                      <div class="t-card__rating">
                        <div class="t-card__rating__count">5.0</div>
                        <div class="t-card__rating__star">Star Comes Here</div>
                      </div>
                    </div>
                  </div>
                  <div class="t-card__google-logo">
                    <img src="https://d18cjm93x7men9.cloudfront.net/img/google-rvw.svg" alt="Google Review" loading="lazy">
                  </div>
                </div>
              </div>
            </div>
            <p>${details}</p>
          </div>
        </div>
      `;

    document.body.appendChild(popup); // Append the popup to the body
    this.existingPopup = popup;
    return popup;
  }

  private openPopup(slideData: Review): void {
    const popup = this.createPopup(slideData); // Call createPopup with slide details
    if (popup) {
      const popupContent = popup.querySelector('.modal__content');

      if (popupContent) {
        // You can customize the popup content based on the slide data
        popupContent.innerHTML = `
          <div class="modal__header">
            <h5 class="modal__title">Review by : ${slideData.author_name}</h5>
            <button class="close">Close</button>
          </div>
          <div class="modal__body">
            <div class="t-card">
              <div class="t-card__inner">
                <div class="t-card__text">
                  <p>${slideData.text}</p>
                </div>
                <div class="t-card__bottom">
                  <div class="t-card__u-info">
                    <div class="t-card__u-info__img-box">
                    <img src=${slideData.profile_photo_url} alt=${slideData.author_name}>
                    </div>
                    <div class="t-card__u-info__right">
                    <div class="t-card__name">${slideData.author_name}</div>
                      <div class="t-card__rating">
                      <div class="t-card__rating__count">${slideData.rating}</div>
                      <div id="ratingContainer" class="t-card__rating__star"></div>
                      </div>
                    </div>
                  </div>
                  <div class="t-card__google-logo">
                    <img src="https://d18cjm93x7men9.cloudfront.net/img/google-rvw.svg" alt="Google Review" loading="lazy">
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

        // Generate stars based on the rating
        const ratingContainer = popupContent.querySelector('#ratingContainer');
        if (ratingContainer) {
          const rating = slideData.rating;
          this.generateStars(rating, ratingContainer);
        }

        const closeBtn = popup.querySelector('.close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            popup.style.display = 'none';
          });
        }
      }

      popup.style.display = 'block';
    }
  }

  // Function to generate stars dynamically
  private generateStars(rating: number, container: HTMLElement): void {
    container.innerHTML = '';

    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');
      star.className = 'star';

      // Fill the star if the current index is less than or equal to the rating
      if (i <= rating) {
        star.innerHTML = '&#9733;'; // Unicode character for a solid star
      } else {
        star.innerHTML = '&#9734;'; // Unicode character for an outline star
      }

      container.appendChild(star);
    }
  }

  private async fetchData(): Promise<Review[]> {
    const apiUrl = `https://api.dabadu.ai/dealers/api/google/reviews-by-location?place_id=${this.widgetData.placeId}&max_limit=${this.widgetData.maxLimit}&rating_value=${this.widgetData.ratingValue}`;

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      const allReviews: Review[] = data?.message?.response?.result?.reviews;

      return allReviews;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }

  public async init(containerId: string): Promise<void> {
    await this.loadSwiperDependencies();
    this.applyStyles();
    const slides = await this.fetchData();
    this.createSlider(containerId, slides);
  }

  private createSlider(containerId: string, slides: Review[]): void {
    const searchContainer = document.getElementById(containerId);

    if (searchContainer && !searchContainer.querySelector('.testimonial-carousel')) {
      const sliderContainer = this.createSwiperContainer();
      searchContainer.appendChild(sliderContainer);

      this.swiper = new Swiper('.testimonial-carousel', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesPerGroup: 1,
        freeMode: true,
        // loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerGroup: 2,
          },
          1200: {
            slidesPerGroup: 3,
          },
          1600: {
            slidesPerGroup: 5,
          },
        },
      });

      this.populateSlides(slides);
      this.setupSlideClickHandler(slides);
    }
  }

  private populateSlides(slides: Review[]): void {
    console.log('slides', slides);
    const wrapper = document.querySelector('.swiper-wrapper');

    slides?.forEach((slideData, index) => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.innerHTML = `
        <div class="t-card">
          <div class="t-card__inner">
            <div class="t-card__text">
              <p>${slideData?.text}</p>
            </div>
            <span class="t-card__read-more">Read More</span>
            <div class="t-card__bottom">
              <div class="t-card__u-info">
                <div class="t-card__u-info__img-box">
                  <img src="${slideData?.profile_photo_url}" alt="${slideData?.author_name}">
                </div>
                <div class="t-card__u-info__right">
                  <div class="t-card__name">${slideData?.author_name}</div>
                  <div class="t-card__rating">
                    <div class="t-card__rating__count">${slideData?.rating}</div>
                    <div id="ratingContainer${index}" class="t-card__rating__star"></div>
                  </div>
                </div>
              </div>
              <div class="t-card__google-logo">
                <img src="https://d18cjm93x7men9.cloudfront.net/img/google-rvw.svg" alt="Google Review" loading="lazy">
              </div>
            </div>
        </div>
      `;

      // Generate stars based on the rating for each slide
      const ratingContainer = slide.querySelector(`#ratingContainer${index}`);
      if (ratingContainer) {
        const rating = slideData.rating;
        this.generateStars(rating, ratingContainer);
      }

      wrapper.appendChild(slide);
    });

    this.swiper.update();
  }

  private setupSlideClickHandler(slides: Review[]): void {
    const readMoreElements = document.querySelectorAll('.t-card__read-more');

    readMoreElements.forEach((readMore, index) => {
      readMore.addEventListener('click', () => {
        console.log('Clicked on "Read More" for slide', index);
        this.openPopup(slides[index]);
      });
    });
  }
}
